import React, { memo } from "react"
import {  Button, Nav, Navbar } from "react-bootstrap"
import { useHistory } from "react-router-dom"
//import {logoutUser} from "../../API/user"
import handwai_logo from "../../Design/logo.png"
import {
    isAdmin,
    isAnalyst,
    isAPPactive,
    isAssistenz,
    isCalculator,
    isHandwaiAssistenz,
    isHandwaiPL,
    isLoggedIn,
    isLVactive,
    isPL,
    isSuperAdmin,
    isUploader
} from "../../Utils"
import { getToken, removeUserSession } from "../../Utils/Common"
import { logoutUser } from "../../API/user";


function MenuComponent() {
    let history = useHistory()

    const handleLogout = async (e) => {
        e.preventDefault()
        await logoutUser()
        localStorage.clear()
        sessionStorage.clear()
        removeUserSession()
        history.push(`${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`)
    }

    return (
        <>
            <Navbar bg="dark" expand="lg">
                <Navbar.Brand href="/">
                    <img
                        alt=""
                        src={handwai_logo}
                        width="130"
                        height="30"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        {/*{!isMobileAppUser() && (*/}
                        {/*	<Nav.Link*/}
                        {/*		key={process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}*/}
                        {/*		href={`${process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}`}*/}
                        {/*	>*/}
                        {/*		{process.env.REACT_APP_FRONTEND_TITLE_DASHBOARD}{" "}*/}
                        {/*	</Nav.Link>*/}
                        {/*)}*/}
                        {isSuperAdmin() && (
                            <Nav.Link
                                key={
                                    process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE
                                }
                                href={`${process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_ORGANISATIONMANAGENTPAGE}{" "}
                            </Nav.Link>
                        )}
                        {isSuperAdmin() && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_PRODUCTMANAGEMENTPAGE}{" "}
                            </Nav.Link>
                        )}
                        {isAdmin() && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_BENUTZERMANAGENTPAGE}{" "}
                            </Nav.Link>
                        )}
                        {/*{(isSuperAdmin() || isAnalyst()) && (*/}
                        {((isAnalyst() || isCalculator()) && isLVactive()) && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
                            </Nav.Link>
                        )}
                        {/*{(isSuperAdmin() || isAnalyst() || isCalculator()) && (*/}
                        {((isAnalyst() || isUploader() || isCalculator()) && isLVactive()) && (

                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
                            </Nav.Link>
                        )}
                        {/*{(isSuperAdmin() || isAnalyst() || isCalculator()) && (*/}
                        {/*{(isAnalyst() || isCalculator()) && (*/}

                        {/*	<Nav.Link*/}
                        {/*		key={process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}*/}
                        {/*		href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}`}*/}
                        {/*	>*/}
                        {/*		{process.env.REACT_APP_FRONTEND_TITLE_ANALYSENPAGE}*/}
                        {/*	</Nav.Link>*/}
                        {/*)}*/}


                        {(((isPL() || isAssistenz()) && isAPPactive()) || (isHandwaiPL() || isHandwaiAssistenz())) && (
                            <>
                                <Nav.Link
                                    key={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}
                                    href={`${process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}`}
                                >
                                    {process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}
                                </Nav.Link>
                            </>
                        )}

                        {(((isPL() || isAssistenz()) && isAPPactive()) || (isHandwaiPL() || isHandwaiAssistenz())) && (
                            <>
                                <Nav.Link
                                    key={process.env.REACT_APP_FRONTEND_PATH_AUFMASPAGE}
                                    href={`${process.env.REACT_APP_FRONTEND_PATH_AUFMASPAGE}`}
                                >
                                    {process.env.REACT_APP_FRONTEND_TITLE_AUFMASPAGE}
                                </Nav.Link>
                            </>
                        )}


                        {((isPL() && isAPPactive()) || isHandwaiPL()) && (
                            <>
                                <Nav.Link
                                    //     key={process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}
                                    //     href={`${process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}`}
                                    // >
                                    //     {process.env.REACT_APP_FRONTEND_TITLE_METAOVERVIEWPAGE}
                                    key={process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}
                                    href={`${process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}`}
                                >
                                    {process.env.REACT_APP_FRONTEND_TITLE_METAOVERVIEWPAGE}
                                </Nav.Link>
                            </>
                        )}



                        {((isPL() && isAPPactive()) || isHandwaiPL()) && (
                            <>
                                <Nav.Link

                                    key={process.env.REACT_APP_FRONTEND_PATH_TAGESBERICHTPAGE}
                                    href={`${process.env.REACT_APP_FRONTEND_PATH_TAGESBERICHTPAGE}`}
                                >
                                    {process.env.REACT_APP_FRONTEND_TITLE_TAGESBERICHTPAGE}
                                </Nav.Link>
                            </>
                        )}

                        {((isAssistenz() && isAPPactive()) || isHandwaiAssistenz()) && (
                            <>
                                <Nav.Link
                                    key={process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}
                                    href={`${process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}`}
                                >
                                    {process.env.REACT_APP_FRONTEND_TITLE_GERAETEPAGE}
                                </Nav.Link>
                            </>
                        )}
                        {((isPL() && isAPPactive()) || isHandwaiPL()) && (
                            <>
                                <Nav.Link
                                    key={process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}
                                    href={`${process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}`}
                                >
                                    {process.env.REACT_APP_FRONTEND_TITLE_MATERIALPAGE}
                                </Nav.Link>
                            </>
                        )}

                        {isAnalyst() && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_DATATOOLPAGE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_DATATOOLPAGE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_DATATOOLPAGE}
                            </Nav.Link>
                        )}

                        {isAnalyst() && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_QADATASETBUILDERPAGE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_QADATASETBUILDERPAGE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_QADATASETBUILDERPAGE}
                            </Nav.Link>
                        )}
                        {((isAnalyst() || isCalculator()) && isLVactive()) && (
                            <Nav.Link
                            style={{
                                position:'relative',
                                marginRight:30,
                            }}
                                key={process.env.REACT_APP_FRONTEND_PATH_TRAINING}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_TRAINING}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_TRAINING}
                                <span style={{
                                    position:'absolute',
                                    backgroundColor:'hsl(47, 100%, 48%)',
                                    color:'black',
                                    padding:3,
                                    right: -20,
                                    borderRadius:25,
                                    fontSize:10,
                                    fontWeight:'bold',
                                }}>
                                    Neu
                                </span>
                            </Nav.Link>
                        )}

                        <Nav.Link
                            key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
                            href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}`}
                        >
                            {process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
                        </Nav.Link>

                        {/* ADDED BY ASIFOR KINGSLEY */}
                        {((isPL() && isAPPactive()) || isHandwaiPL()) && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_TEXT_TEMPLATE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_TEXT_TEMPLATE}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TEXT_TEMPLATE}
                            </Nav.Link>)}
                        {/*{!isMobileAppUser() && (*/}
                        {/*	<Nav.Link*/}
                        {/*		key={process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}*/}
                        {/*		href={`${process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}`}*/}
                        {/*	>*/}
                        {/*		{process.env.REACT_APP_FRONTEND_TITLE_LIVECALLPAGE}*/}
                        {/*	</Nav.Link>*/}
                        {/*)}*/}
                        <Nav.Link
                            key={process.env.REACT_APP_FRONTEND_PATH_FAQ}
                            href={`${process.env.REACT_APP_FRONTEND_PATH_FAQ}`}
                        >
                            {process.env.REACT_APP_FRONTEND_TITLE_FAQ}
                        </Nav.Link>

                        {!isLoggedIn() && (
                            <Nav.Link
                                key={process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE}
                                href={`${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`}
                            >
                                {process.env.REACT_APP_FRONTEND_TITLE_LANDINGPAGE}
                            </Nav.Link>
                        )}
                    </Nav>

                    {isLoggedIn() && getToken() && (
                        <Button className="handwai-btn-logout"
                            onClick={handleLogout}>
                            Abmeldung
                        </Button>
                    )}
                </Navbar.Collapse>
            </Navbar>
        </>
    )
}

export default memo(MenuComponent);








////////1st aug 2023 backup//////
// function MenuComponent() {
// 	let history = useHistory()
//
// 	const handleLogout = async (e) => {
// 		e.preventDefault()
// 		await logoutUser()
// 		localStorage.clear()
// 		sessionStorage.clear()
// 		removeUserSession()
// 		history.push(`${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`)
// 	}
//
// 	return (
// 		<>
// 			<Navbar bg="dark" expand="lg">
// 				<Navbar.Brand href="/">
// 					<img
// 						alt=""
// 						src={handwai_logo}
// 						width="130"
// 						height="30"
// 						className="d-inline-block align-top"
// 					/>
// 				</Navbar.Brand>
// 				<Navbar.Toggle aria-controls="basic-navbar-nav"/>
// 				<Navbar.Collapse id="basic-navbar-nav">
// 					<Nav className="mr-auto">
// 						{/*{!isMobileAppUser() && (*/}
// 						{/*	<Nav.Link*/}
// 						{/*		key={process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}*/}
// 						{/*		href={`${process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}`}*/}
// 						{/*	>*/}
// 						{/*		{process.env.REACT_APP_FRONTEND_TITLE_DASHBOARD}{" "}*/}
// 						{/*	</Nav.Link>*/}
// 						{/*)}*/}
// 						{isSuperAdmin() && (
// 							<Nav.Link
// 								key={
// 									process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE
// 								}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_ORGANISATIONMANAGENTPAGE}{" "}
// 							</Nav.Link>
// 						)}
// 						{isSuperAdmin() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_PRODUCTMANAGEMENTPAGE}{" "}
// 							</Nav.Link>
// 						)}
// 						{isAdmin() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_BENUTZERMANAGENTPAGE}{" "}
// 							</Nav.Link>
// 						)}
// 						{/*{(isSuperAdmin() || isAnalyst()) && (*/}
// 												{(isAnalyst()) && (
//
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
// 							</Nav.Link>
// 						)}
// 						{/*{(isSuperAdmin() || isAnalyst() || isCalculator()) && (*/}
// 													{(isAnalyst() || isCalculator()) && (
//
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
// 							</Nav.Link>
// 						)}
// 						{/*{(isSuperAdmin() || isAnalyst() || isCalculator()) && (*/}
// 												{(isAnalyst() || isCalculator()) && (
//
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_ANALYSENPAGE}
// 							</Nav.Link>
// 						)}
// 						{isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_METAOVERVIEWPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_GERAETEPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_MATERIALPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
// 						<Nav.Link
// 							key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
// 							href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}`}
// 						>
// 							{process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
// 						</Nav.Link>
// 						{/*{!isMobileAppUser() && (*/}
// 						{/*	<Nav.Link*/}
// 						{/*		key={process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}*/}
// 						{/*		href={`${process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}`}*/}
// 						{/*	>*/}
// 						{/*		{process.env.REACT_APP_FRONTEND_TITLE_LIVECALLPAGE}*/}
// 						{/*	</Nav.Link>*/}
// 						{/*)}*/}
// 						{!isMobileAppUser() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_FAQ}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_FAQ}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_FAQ}
// 							</Nav.Link>
// 						)}
//
// 						{!isLoggedIn() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_LANDINGPAGE}
// 							</Nav.Link>
// 						)}
// 					</Nav>
//
// 					{isLoggedIn() && getToken() && (
// 						<Button className="handwai-btn-logout"
// 						        onClick={handleLogout}>
// 							Abmeldung
// 						</Button>
// 					)}
// 				</Navbar.Collapse>
// 			</Navbar>
// 		</>
// 	)
// }
//
// export default memo(MenuComponent);




/////////////////////////
// return (
// 		<>
// 			<Navbar bg="dark" expand="lg">
// 				<Navbar.Brand href="/">
// 					<img
// 						alt=""
// 						src={handwai_logo}
// 						width="130"
// 						height="30"
// 						className="d-inline-block align-top"
// 					/>
// 				</Navbar.Brand>
// 				<Navbar.Toggle aria-controls="basic-navbar-nav"/>
// 				<Navbar.Collapse id="basic-navbar-nav">
// 					<Nav className="mr-auto">
// 						{!isMobileAppUser() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_DASHBOARD}{" "}
// 							</Nav.Link>
// 						)}
// 						{isSuperAdmin() && (
// 							<Nav.Link
// 								key={
// 									process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE
// 								}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_ORGANISATIONMANAGENTPAGE}{" "}
// 							</Nav.Link>
// 						)}
// 						{isSuperAdmin() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_PRODUCTMANAGEMENTPAGE}{" "}
// 							</Nav.Link>
// 						)}
// 						{isAdmin() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_BENUTZERMANAGENTPAGE}{" "}
// 							</Nav.Link>
// 						)}
// 						{(isSuperAdmin() || isAnalyst()) && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
// 							</Nav.Link>
// 						)}
// 						{(isSuperAdmin() || isAnalyst() || isCalculator()) && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
// 							</Nav.Link>
// 						)}
// 						{(isSuperAdmin() || isAnalyst() || isCalculator()) && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_ANALYSENPAGE}
// 							</Nav.Link>
// 						)}
// 						{isMobileAppUser() && (
// 							<>
// 								<Nav.Link
// 									key={process.env.REACT_APP_FRONTEND_PATH_PROJECTSPAGE}
// 									href={`${process.env.REACT_APP_FRONTEND_PATH_PROJECTSPAGE}`}
// 								>
// 									{process.env.REACT_APP_FRONTEND_TITLE_PROJECTSPAGE}
// 								</Nav.Link>
// 								<Nav.Link
// 									key={process.env.REACT_APP_FRONTEND_PATH_BAUTAGEBUCHPAGE}
// 									href={`${process.env.REACT_APP_FRONTEND_PATH_BAUTAGEBUCHPAGE}`}
// 								>
// 									{process.env.REACT_APP_FRONTEND_TITLE_BAUTAGEBUCHPAGE}
// 								</Nav.Link>
// 							</>
// 						)}
// 						<Nav.Link
// 							key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
// 							href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}`}
// 						>
// 							{process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
// 						</Nav.Link>
// 						{/*{!isMobileAppUser() && (*/}
// 						{/*	<Nav.Link*/}
// 						{/*		key={process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}*/}
// 						{/*		href={`${process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}`}*/}
// 						{/*	>*/}
// 						{/*		{process.env.REACT_APP_FRONTEND_TITLE_LIVECALLPAGE}*/}
// 						{/*	</Nav.Link>*/}
// 						{/*)}*/}
// 						{!isMobileAppUser() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_FAQ}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_FAQ}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_FAQ}
// 							</Nav.Link>
// 						)}
//
// 						{!isLoggedIn() && (
// 							<Nav.Link
// 								key={process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE}
// 								href={`${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`}
// 							>
// 								{process.env.REACT_APP_FRONTEND_TITLE_LANDINGPAGE}
// 							</Nav.Link>
// 						)}
// 					</Nav>
//
// 					{isLoggedIn() && getToken() && (
// 						<Button className="handwai-btn-logout"
// 						        onClick={handleLogout}>
// 							Abmeldung
// 						</Button>
// 					)}
// 				</Navbar.Collapse>
// 			</Navbar>
// 		</>
// 	)
//
//     return (
//         <>
//             <Navbar bg="dark" expand="lg">
//                 <Navbar.Brand href="/">
//                     <img alt="" src={handwai_logo}
//                          width="130" height="30"
//                          className="d-inline-block align-top"/>
//                 </Navbar.Brand>
//                 <Navbar.Toggle
//                     aria-controls="basic-navbar-nav"/>
//                 <Navbar.Collapse id="basic-navbar-nav">
//                     <Nav className="mr-auto">
//                         {!isMobileAppUser() && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_DASHBOARD}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_DASHBOARD}{' '}
//                             </Nav.Link>
//                         )}
//                         {isSuperAdmin() && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_ORGANISATIONMANAGENTPAGE}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_ORGANISATIONMANAGENTPAGE}{' '}
//                             </Nav.Link>
//                         )}
//                         {isSuperAdmin() && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_PRODUCTMANAGEMENTPAGE}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_PRODUCTMANAGEMENTPAGE}{' '}
//                             </Nav.Link>
//                         )}
//                         {isAdmin() && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERMANAGENTPAGE}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_BENUTZERMANAGENTPAGE}{' '}
//                             </Nav.Link>
//                         )}
//                         {(isSuperAdmin() || isAnalyst()) && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSEREQUESTPAGE}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_ANALYSEREQUESTPAGE}
//                             </Nav.Link>
//                         )}
//                         {(isSuperAdmin() || isAnalyst() || isCalculator()) && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_LVHOCHLADEN}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_LVHOCHLADEN}
//                             </Nav.Link>
//                         )}
//                         {(isSuperAdmin() || isAnalyst() || isCalculator()) && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_ANALYSENPAGE}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_ANALYSENPAGE}
//                             </Nav.Link>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_PROJECTSOVERVIEWPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_PROJECTSOVERVIEWPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_METAOVERVIEWPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_METAOVERVIEWPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_GERAETEPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_GERAETEPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_MATERIALPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_MATERIALPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//
//
//                         {!isMobileAppUser() && (
//                             <>
//                                 <Nav.Link
//                                     key={process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}
//                                     href={`${process.env.REACT_APP_FRONTEND_PATH_BENUTZERPROFILPAGE}`}
//                                 >
//                                     {process.env.REACT_APP_FRONTEND_TITLE_BENUTZERPROFILPAGE}
//                                 </Nav.Link>
//                             </>
//                         )}
//                         {/*{!isMobileAppUser() && (*/}
//                         {/*	<Nav.Link*/}
//                         {/*		key={process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}*/}
//                         {/*		href={`${process.env.REACT_APP_FRONTEND_PATH_LIVECALLPAGE}`}*/}
//                         {/*	>*/}
//                         {/*		{process.env.REACT_APP_FRONTEND_TITLE_LIVECALLPAGE}*/}
//                         {/*	</Nav.Link>*/}
//                         {/*)}*/}
//                         {!isMobileAppUser() && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_FAQ}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_FAQ}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_FAQ}
//                             </Nav.Link>
//                         )}
//
//                         {!isLoggedIn() && (
//                             <Nav.Link
//                                 key={process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE}
//                                 href={`${process.env.REACT_APP_FRONTEND_PATH_LOGIN}`}
//                             >
//                                 {process.env.REACT_APP_FRONTEND_TITLE_LANDINGPAGE}
//                             </Nav.Link>
//                         )}
//                     </Nav>
//
//                     {isLoggedIn() && getToken() && (
//                         <Button
//                             className="handwai-btn-logout"
//                             onClick={handleLogout}>
//                             Abmeldung
//                         </Button>
//                     )}
//                 </Navbar.Collapse>
//             </Navbar>
//         </>
//     );
// }
